import * as React from "react";
import {
  Avatar as ShadcnAvatar,
  AvatarImage as ShadcnAvatarImage,
  AvatarFallback,
} from "../avatar";
import { cn } from "@/lib/utils";

// Avatar with Hero UI compatible props
export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  size?: "sm" | "md" | "lg";
  radius?: "none" | "sm" | "md" | "lg" | "full";
  className?: string;
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  (
    { src, alt, size = "md", radius = "full", className, children, ...props },
    ref
  ) => {
    const sizeClasses = {
      sm: "h-6 w-6",
      md: "h-10 w-10",
      lg: "h-16 w-16",
    };

    const radiusClasses = {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      full: "rounded-full",
    };

    return (
      <ShadcnAvatar
        ref={ref}
        className={cn(sizeClasses[size], radiusClasses[radius], className)}
        {...props}
      >
        {src && <ShadcnAvatarImage src={src} alt={alt} />}
        {children}
      </ShadcnAvatar>
    );
  }
);
Avatar.displayName = "Avatar";

// Re-export AvatarImage and AvatarFallback
export { Avatar };
export const AvatarImage = ShadcnAvatarImage;
export { AvatarFallback };
